import BrandedLogo from './branded-logo'

const PageLoader = () => {
    return (
        <div className='w-[100%] h-[100vh] bg-background flex items-center justify-center'>
            <div className="w-[45%] h-[100%] flex items-center justify-center relative" >
                <div className='h-[400px] w-[450px] blur-3xl rounded-[50%] bg-indigo-600/25 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] animate-pulse'></div>
                <div className=" p-[30px] text-center border-r-[50%] relative animate-page-loader">
                    <p className="text-[55px]">👋</p>
                    <BrandedLogo className="w-[300px] mt-2 h-[auto] object-cover" alt="" />
                </div>
            </div>
        </div>
    )
}

export default PageLoader
